import axios from "axios";
import xss from "xss";

import store from "../../store";
import { configActions, basketActions } from "../../actions";
import console from "./console";
import { decode, encode, hasCrypto } from "./crypt";

export const storeDataForYesLogin = async () => {
  const { configStorage, basketStorage } = store.getState();
  let result = null;
  let yesRequested = localStorage.getItem("yesLoginRequested");
  if (yesRequested !== "yes") {
    const objektheader = configStorage.getRequestHeader();
    axios.defaults.headers.common['request'] = JSON.stringify(objektheader);
    const yesLoginRequestData = configStorage.getRequestData("yesLogin", "post");
    const yesLoginResponse = await axios[yesLoginRequestData.request.type](yesLoginRequestData.url, yesLoginRequestData.json);
    result = yesLoginResponse ? yesLoginResponse.data || null : null;
    const dataForOrder = basketStorage.getDataForOrder();
    const sessionData = {
      sessionId: configStorage.getSessionId(),
      warenkorbId: basketStorage.warenkorbId,
      orderData: dataForOrder.orderData,
      selectedFiliale: dataForOrder.selectedFiliale,
      doShip: dataForOrder.doShip,
      requestHeader: objektheader,
      gebuehren: dataForOrder.gebuehren || {},
      warenkorbData: basketStorage.getDataForCart()
    };
    if (hasCrypto()) {
      await encode(JSON.stringify(sessionData), configStorage.getAppId())
        .then(sessionStore => {
          result = { ...result, sessionData: { sessionStore } };
        })
        .catch(e => {
          console.debug("encryption failed", e);
          result = { ...result, sessionData };
        })
        .finally(() => {
          localStorage.setItem("yesLoginRequested", "yes");
        });
    } else {
      result = { ...result, sessionData };
      localStorage.setItem("yesLoginRequested", "yes");
    }
  }
  return result;
};

export const postYesLogin = async () => {
  const { configStorage } = store.getState();
  const params = new URL(window.location).searchParams;
  let code = xss(params.get("code")) || undefined;
  let state = xss(params.get("state")) || undefined;
  let iss = xss(params.get("iss")) || undefined;
  let issuerUrl = xss(params.get("issuerUrl")) || undefined;
  let error = xss(params.get("error")) || undefined;
  let errorDesc = xss(params.get("error_description")) || undefined;
  let yesCustomerRequestData = configStorage.getRequestData("yesResponseExt", "post");
  const yesResponse = await axios.post(yesCustomerRequestData.url, {
    code,
    state,
    iss,
    issuerUrl,
    error,
    errorDesc
  });
  localStorage.removeItem("yesLoginRequested");
  localStorage.removeItem("sessionId");
  localStorage.removeItem("warenkorbId");
  localStorage.removeItem("warenkorbData");
  localStorage.removeItem("orderData");
  localStorage.removeItem("selectedFiliale");
  localStorage.removeItem("doShip");
  localStorage.removeItem("requestHeader");
  localStorage.removeItem("gebuehren");
  localStorage.removeItem("sessionStore");
  return yesResponse;
};

export const handleYesLogin = async () => {
  const { configStorage } = store.getState();
  const dispatch = store.dispatch;
  let yesRequested = localStorage.getItem("yesLoginRequested");
  const reset = (sessionStore) => {
    const { sessionId, warenkorbId, warenkorbData, doShip, gebuehren, selectedFiliale, orderData, requestHeader } = sessionStore;
    dispatch(configActions.setSessionId(sessionId));
    dispatch(basketActions.restoreData({
      warenkorbId,
      doShip,
      gebuehren,
      selectedFiliale,
      orderDataForOrder: orderData,
      orderData: warenkorbData
    }));
    configStorage.setRequestHeader(requestHeader);
  };
  if (yesRequested === "yes" && window.location.pathname.indexOf("login") > -1) {
    //Aktuell notwendig, da die Daten nach dem Redirect aus configStorage alle verschwinden.
    if (hasCrypto()) {
      await decode(JSON.parse(localStorage.getItem("sessionStore")), configStorage.getAppId())
        .then(sessionStore => {
          console.debug("store", sessionStore);

          return reset(JSON.parse(sessionStore));
        })
        .catch(e => {
          console.debug("no encrypted data", e);
          reset({
            sessionId: localStorage.getItem("sessionId"),
            warenkorbId: localStorage.getItem("warenkorbId"),
            doShip: JSON.parse(`${localStorage.getItem("doShip") || '""'}`),
            gebuehren: JSON.parse(`${localStorage.getItem("gebuehren")}`),
            selectedFiliale: JSON.parse(`${localStorage.getItem("selectedFiliale")}`),
            orderData: JSON.parse(`${localStorage.getItem("orderData")}`),
            warenkorbData: JSON.parse(`${localStorage.getItem("warenkorbData")}`),
            requestHeader: JSON.parse(`${localStorage.getItem("requestHeader")}`)
          });
        });
    } else {
      reset({
        sessionId: localStorage.getItem("sessionId"),
        warenkorbId: localStorage.getItem("warenkorbId"),
        doShip: JSON.parse(`${localStorage.getItem("doShip") || '""'}`),
        gebuehren: JSON.parse(`${localStorage.getItem("gebuehren")}`),
        selectedFiliale: JSON.parse(`${localStorage.getItem("selectedFiliale")}`),
        orderData: JSON.parse(`${localStorage.getItem("orderData")}`),
        warenkorbData: JSON.parse(`${localStorage.getItem("warenkorbData")}`),
        requestHeader: JSON.parse(`${localStorage.getItem("requestHeader")}`)
      });
    }
    return true;
  } else {
    localStorage.removeItem("yesLoginRequested");
    return false;
  }
};

export default handleYesLogin;
